import { createContext } from 'react';

// HACK: Is this even being used? I have no idea what I'm doing.

interface ILanguageSelectorContext {
    selectedLanguage: string;
    setSelectedLanguage: (language: string) => void;
}

export const LanguageSelectorContext = createContext<ILanguageSelectorContext>({
    selectedLanguage: '',
    setSelectedLanguage: () => {},
});